<template>
    <div id="monitor">
        <comheader></comheader>
        <div class="rf ks_right" id="rmodel">
            <comtop></comtop>
            <el-main>
                <div class="com_topaside">
                    <span>培训<b>></b></span>
                    <span>考试管理<b>></b></span>
                    <span>考试任务<b></b></span>
                </div>
            </el-main>
            <div class="monitorName">
                <div class="monitor_wrap">
                    <h3>{{title}}</h3>
                    <p>创建人：{{create_name}}<b>|</b>合格线：{{score}}%</p>
                </div>
            </div>
            <el-main class="exam_wrap">
                <div class="monitor_top">
                    <el-menu :default-active="activeIndex" class="monitor_bread lf" mode="horizontal" text-color="#333">
                        <el-menu-item index="1"><router-link :to="{name:'peomonitor',query:{id:id}}">人员监控</router-link></el-menu-item>
                        <el-menu-item index="2"><router-link :to="{name:'analysis',query:{id:id}}">试题分析</router-link></el-menu-item>
                        <el-menu-item index="3"><router-link :to="{name:'makeup',query:{id:id}}">补考明细</router-link></el-menu-item>
                    </el-menu>
                    <el-input placeholder="请输入内容" v-model="input" class="monitor_search rf" @change="seacrchTxt"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                </div>
                <div class="clear"></div>
                <router-view  :taskListSear.sync='taskList' :count.sync='count' :searchtxt.sync='input'></router-view>
            </el-main>
        </div>
    </div>
</template>

<script>
import comheader from '../Common/comheader'
import comtop from '../Common/comtop'
import analysis from './analysis'
 export default{
    name:'monitor',
    data(){
        return{
            input:'',
            checked:false,
            taskList:[],
            value:[],
            options:[],
            activeIndex:'1',
            id:this.$route.query.id,
            title:'',
            create_name:'',
            count:0,
            score:'',
        }
    },
    components:{
        comheader,
        comtop,
        analysis
    },
    methods:{
        seacrchTxt(e){
            if(this.$route.name=='peomonitor'){
                    var data={
                        service:'Examtask.Examlog1',
                        id:this.id,
                        limit:this.limit,
                        page:this.page,
                        nickname:e,
                        // userid:localStorage.getItem('userid')
                        userid: 21343
                    }
                    var tklist=[]
                    this.$axios.post(this.HOME,this.$qs.stringify(data))
                    .then(res=>{
                         if(res.data.data.code == 1){
                            this.alertView.failView('没有数据')
                            this.taskList = []
                            return false
                        }
                        this.count=parseInt(res.data.data.info.count)
                        for(var i=0;i<res.data.data.info.list.length;i++){
                            tklist.push(res.data.data.info.list[i])
                        }
                         for(var x=0;x<tklist.length;x++){
                            if(tklist[x].num>"1"){
                                tklist[x].grade=tklist[x].grade+'(补考)'
                            }
                        }
                        this.taskList=tklist
                        this.taskList=tklist
                        console.log(this.count)
                    })
            }
            else if(this.$route.name=='analysis'){
                var data={
                service:'Examtask.QsnAnalyze',
                id:this.id,
                where:e,
                limit:10,
                page:1
            }
            var tklist=[]
            this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
                if(res.data.data.code==0){
                    for(var i=0;i<res.data.data.info.list.length;i++){
                        tklist.push(res.data.data.info.list[i])
                        if(res.data.data.info.list[i].q_type==1){
                            var levelTxt='单选'
                        }
                        else if(res.data.data.info.list[i].q_type==2){
                            var levelTxt='判断'
                        }
                        else if(res.data.data.info.list[i].q_type==3){
                            var levelTxt='填空'
                        }
                        else if(res.data.data.info.list[i].q_type==4){
                            var levelTxt='简答'
                        }
                        else{
                            var levelTxt='多选'
                        }
                        if(res.data.data.info.list[i].level==1){
                            var levelUp='简单'
                        }
                        else if(res.data.data.info.list[i].level==2){
                            var levelUp='一般'
                        }
                        else if(res.data.data.info.list[i].level==3){
                            var levelUp='较难'
                        }
                        else{
                            var levelUp='困难'
                        }
                            tklist[i].level=levelUp
                            tklist[i].q_type=levelTxt
                    }
                    this.taskList=tklist
                }
                else{
                    this.taskList=tklist
                    this.alertView.failView('没有搜索到该试题')
                }
            })
            }
            else if(this.$route.name=='makeup'){
                var data={
                service:'Examtask.Detail',
                id:this.id,
                where:e,
            }
            var tklist=[]
            this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
                if(res.data.data.code==0){
                    for(var i=0;i<res.data.data.info.list.length;i++){
                        tklist.push(res.data.data.info.list[i])
                        if(res.data.data.info.list[i].states==1){
                            var levelTxt='及格'
                        }
                        
                        else{
                            var levelTxt='不及格'
                        }
                        tklist[i].states=levelTxt
                    }
                }
                else{
                    this.alertView.failView('没有搜索到该试题')
                }
                this.taskList=tklist
            })
            }
        }
    },
    watch:{
        $route(){
           this.input=''
        }
    },
    mounted(){
        this.$router.push({path:'/monitor/peomonitor',query:{id:this.id}})
        var data={
                service:'Examtask.Examlog1',
                id:this.id,
                limit:this.limit,
                page:this.page,
                // userid:localStorage.getItem('userid')
                userid: 21343
            }
            var tklist=[]
            this.$axios.post(this.HOME,this.$qs.stringify(data))
            .then(res=>{
                this.count=parseInt(res.data.data.info.count)
                this.title=res.data.data.info.title;
                this.create_name=res.data.data.info.create_name;
                this.score=res.data.data.info.score
            })
    },
 
 }
</script>
<style>
    @import "../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/task/monitor.vue